import {Injectable} from '@angular/core';
import {webapi} from '../../shared/my-constants';
import {Headers, Http, Response} from '@angular/http';

@Injectable()
export class TrnBillBillSponsorService {
  mstUnit: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecordByBill = webapi + 'trn_bill_bill_sponsor/listbybillid/?';
  private AddRecord = webapi + 'trn_bill_bill_sponsor/create';

  constructor(private http: Http) {
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordByBill(billId: any) {
    return this.http.get(this.ListRecordByBill + 'billId=' + billId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/trn-bill-bill-sponsor/trn-bill-bill-sponsor.service.ts